
import { useState } from "react";
import { Box, Tab, Tabs, } from "@mui/material";
import { EstadoReferidoChoiceEnum, a11yProps, sizeTab, texto, useCheckPermissions } from "@/shared";

import { PermissionsEnum } from "@/auth/interfaces";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { CustomTabPanel } from "@/erp/sale/component";
import TableReferidoComponente from "../componente/TableReferidoComponente";

export default function ReferidoPage() {

  useCheckPermissions(PermissionsEnum.api_view_prospecto);
  const [valueTab, setValueTab] = useState(0);


  return (
    <SingleTableBoxScene
      title={"Referidos"}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={texto.pendiente} {...a11yProps(0)} />
          <Tab label={texto.aceptar} {...a11yProps(1)} />
          <Tab label={texto.rechazadas} {...a11yProps(2)} />
          <Tab label={'Empleado'} {...a11yProps(2)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <TableReferidoComponente estado_referido={EstadoReferidoChoiceEnum.PENDIENTE} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableReferidoComponente estado_referido={EstadoReferidoChoiceEnum.ACEPTADO} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableReferidoComponente estado_referido={EstadoReferidoChoiceEnum.RECHAZADO} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={3}>
        <TableReferidoComponente 
          estado_referido={null} 
          tipo_referido="EMPLEADO" 
          estado_preventa_exclude={null}
        />
      </CustomTabPanel>
    </SingleTableBoxScene >
  );


}